import { AnimatePresence, motion } from "framer-motion";
import { Link, useLocation } from "react-router-dom";
import { FaHome, FaUser, FaEnvelope, FaBriefcase } from "react-icons/fa";

const links = [
  { to: "/",        text: "Home",    Icon: FaHome },
  { to: "/about",   text: "About",   Icon: FaUser },
  { to: "/work",    text: "Work",    Icon: FaBriefcase },
  { to: "/contact", text: "Contact", Icon: FaEnvelope },
];

export default function MobileView({ showMenu: isOpen, onClose }) {
  const { pathname } = useLocation();

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            key="backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 z-20 bg-black/50"
          />
          <motion.aside
            key="sidebar"
            initial={{ x: "-100%" }}
            animate={{ x: 0 }}
            exit={{ x: "-100%" }}
            transition={{ type: "tween", duration: 0.28, ease: "easeInOut" }}
            className="fixed top-0 left-0 z-30 h-screen w-64 bg-[#584f44] flex flex-col pt-20 px-4 shadow-2xl"
          >
            <nav className="flex flex-col gap-2">
              {links.map(({ to, text, Icon }) => {
                const isActive = pathname === to;
                return (
                  <Link
                    key={to}
                    to={to}
                    onClick={onClose}
                    className={`flex items-center gap-4 px-4 py-3 rounded-lg transition-all duration-200
                      ${isActive
                        ? "bg-[#b87333]/25 text-[#dc8c41]"
                        : "text-[#acacba] hover:bg-white/5 hover:text-cyan-200"
                      }`}
                  >
                    <Icon className="text-xl flex-shrink-0" />
                    <span className="text-sm font-medium tracking-wide">{text}</span>
                    {isActive && (
                      <span className="ml-auto w-1.5 h-1.5 rounded-full bg-[#b87333]" />
                    )}
                  </Link>
                );
              })}
            </nav>
          </motion.aside>
        </>
      )}
    </AnimatePresence>
  );
}
